(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bl-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!root || root.dataset.blHcInit === 'true') return;
      root.dataset.blHcInit = 'true';
      var track = root.querySelector('[data-bl-carousel-track]');
      var slides = root.querySelectorAll('[data-bl-carousel-slide]');
      var dots = root.querySelectorAll('[data-bl-carousel-dot]');
      var prev = root.querySelector('[data-bl-carousel-prev]');
      var next = root.querySelector('[data-bl-carousel-next]');
      var n = slides.length;
      if (!track || n === 0) return;

      var idx = 0;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = (root.dataset.autoplay === 'true') && !reduce && n > 1;
      var interval = parseInt(root.dataset.interval, 10);
      if (!interval || interval < 2000) interval = 6000;
      var timer = null;

      function revealMotion(slide) {
        var m = slide.querySelector('[data-bl-hero-motion].is-pending');
        if (m) { m.classList.remove('is-pending'); m.classList.add('is-ready'); }
      }
      function render() {
        track.style.transform = 'translateX(' + (-idx * 100) + '%)';
        for (var i = 0; i < dots.length; i++) {
          var on = (i === idx);
          dots[i].classList.toggle('is-on', on);
          dots[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        for (var j = 0; j < n; j++) {
          slides[j].setAttribute('aria-hidden', j === idx ? 'false' : 'true');
        }
      }
      function goTo(i) {
        idx = ((i % n) + n) % n;
        render();
        revealMotion(slides[idx]);
      }
      function nextSlide() { goTo(idx + 1); }
      function prevSlide() { goTo(idx - 1); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { if (autoplay && !timer && !document.hidden) { timer = setInterval(nextSlide, interval); } }
      function restart() { stop(); start(); }

      if (next) next.addEventListener('click', function () { nextSlide(); restart(); });
      if (prev) prev.addEventListener('click', function () { prevSlide(); restart(); });
      for (var d = 0; d < dots.length; d++) {
        (function (k) { dots[k].addEventListener('click', function () { goTo(k); restart(); }); })(d);
      }

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { nextSlide(); restart(); }
        else if (e.key === 'ArrowLeft') { prevSlide(); restart(); }
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });

      var x0 = null, y0 = null, swiping = false;
      root.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; swiping = true; stop();
      }, { passive: true });
      root.addEventListener('touchmove', function (e) {
        if (!swiping) return;
        var t = e.touches[0];
        if (Math.abs(t.clientY - y0) > Math.abs(t.clientX - x0) + 8) { swiping = false; }
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (!swiping) { start(); return; }
        swiping = false;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { if (dx < 0) nextSlide(); else prevSlide(); }
        restart();
      });

      render();
      start();
    }
    function storeStatus(open, close, days) {
      var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }));
      var d = now.getDay(), h = now.getHours() + now.getMinutes() / 60;
      var openDays = days === 'daily' ? [0, 1, 2, 3, 4, 5, 6] : [5, 6, 0];
      var fmt = function (hr) { var ap = hr >= 12 ? 'PM' : 'AM'; var hh = hr % 12; if (hh === 0) hh = 12; return hh + ' ' + ap; };
      var names = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      if (openDays.indexOf(d) > -1 && h >= open && h < close) { return { open: true, text: 'Open now · Closes ' + fmt(close) }; }
      for (var i = 0; i < 8; i++) {
        var cd = (d + i) % 7;
        if (openDays.indexOf(cd) > -1) {
          if (i === 0 && h < open) { return { open: false, text: 'Closed · Opens ' + fmt(open) }; }
          if (i > 0) { return { open: false, text: 'Closed · Opens ' + names[cd] + ' ' + fmt(open) }; }
        }
      }
      return { open: false, text: 'Closed' };
    }
    function initStores(root) {
      var els = (root || document).querySelectorAll('[data-bl-hc-store]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var st = storeStatus(parseFloat(el.getAttribute('data-open')), parseFloat(el.getAttribute('data-close')), el.getAttribute('data-days'));
        var badge = el.querySelector('[data-bl-hc-badge]'), txt = el.querySelector('[data-bl-hc-badge-txt]');
        if (txt) { txt.textContent = st.text; }
        if (badge) { badge.classList.toggle('is-open', st.open); }
      }
    }
    function initAll(root) {
      (root || document).querySelectorAll('[data-bl-hero-carousel]').forEach(initCarousel);
      initStores(root);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	function btyHeaderSticky( doc = document ) {
		let hasTopbar = document.querySelector( '.topbar-section ~ .header-section' ),
			header    = doc.querySelector( '.header.transparent-header' );

		function onShopifyLoaded( callback ) {
			if ( ! header ) {
				setTimeout(
					function() {
						onShopifyLoaded( callback )
					}
				);

				return;
			}

			callback();
		}

		onShopifyLoaded(
			function() {
				if ( ! header ) {
					return;
				}

				const detectScroll = function() {
					if ( window.scrollY > 50 ) {
						header.classList.add( 'is-sticky' );
					} else {
						header.classList.remove( 'is-sticky' );
					}
				}

				if ( Shopify.designMode || ! hasTopbar ) {
					detectScroll();
					window.addEventListener( 'scroll', detectScroll );
				} else {
					const observer = new IntersectionObserver(
						([e]) => e.target.classList.toggle( 'is-sticky', e.intersectionRatio < 1 ),
						{
							rootMargin: '-1px 0px 0px 0px',
							threshold: [1]
						}
					);

					observer.observe( header );
				}
			}
		)
	}

	btyHeaderSticky();

	document.addEventListener(
		'shopify:section:select',
		function( e ) {
			let section = e.target;
			btyHeaderSticky( section );
		}
	);

	document.addEventListener(
		'shopify:block:select',
		function( e ) {
			let section = document.getElementById( 'shopify-section-' + e.detail.sectionId );
			btyHeaderSticky( section );
		}
	);

  } catch(e) { console.error(e); }
})();
})();
